import { trackingEvent } from '@notino/web-tracking';

import { ErrorCodes } from '@utils/constants';
import { getTrackingProductName } from '@utils/tracking';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { EcommerceSectionNamespace, EItemGroup, IEcommerceProduct } from '../../model';

export const trackAddToCartEditEvent = (product: IEcommerceProduct, quantity: number) => {
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.ADD_TO_CART_EDIT,
      add: {
        products: [
          {
            product_code: product.productCode,
            product_name: getTrackingProductName(product),
            brand_name: product.productName,
            quantity: quantity,
            full_price: product.fullPrice,
            cart_type: product.cartType,
            primary_category: product.primaryCategories.category,
            primary_subcategory: product.primaryCategories.subCategory,
            primary_type: product.primaryCategories.type,
            kind: product.primaryCategories.kind,
            list_position: product.listPosition,
            list_name: product.listName,
            group: EItemGroup.PRODUCT,
            price: product.price,
          },
        ],
      },
      error: {
        status: ErrorCodes.SC_EXCEEDED_ITEM_COUNT,
      },
      _clear: true,
    }),
  );
};
